/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthSubmissionDocument } from './PalReauthSubmissionDocument';
import {
    PalReauthSubmissionDocumentFromJSON,
    PalReauthSubmissionDocumentFromJSONTyped,
    PalReauthSubmissionDocumentToJSON,
    PalReauthSubmissionDocumentToJSONTyped,
} from './PalReauthSubmissionDocument';

/**
 * 
 * @export
 * @interface CreatePalReauthAdditionalDocument201Response
 */
export interface CreatePalReauthAdditionalDocument201Response {
    /**
     * 
     */
    data?: PalReauthSubmissionDocument;
}

/**
 * Check if a given object implements the CreatePalReauthAdditionalDocument201Response interface.
 */
export function instanceOfCreatePalReauthAdditionalDocument201Response(value: object): value is CreatePalReauthAdditionalDocument201Response {
    return true;
}

export function CreatePalReauthAdditionalDocument201ResponseFromJSON(json: any): CreatePalReauthAdditionalDocument201Response {
    return CreatePalReauthAdditionalDocument201ResponseFromJSONTyped(json, false);
}

export function CreatePalReauthAdditionalDocument201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePalReauthAdditionalDocument201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PalReauthSubmissionDocumentFromJSON(json['data']),
    };
}

export function CreatePalReauthAdditionalDocument201ResponseToJSON(json: any): CreatePalReauthAdditionalDocument201Response {
    return CreatePalReauthAdditionalDocument201ResponseToJSONTyped(json, false);
}

export function CreatePalReauthAdditionalDocument201ResponseToJSONTyped(value?: CreatePalReauthAdditionalDocument201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PalReauthSubmissionDocumentToJSON(value['data']),
    };
}

